// @ts-nocheck
import { axiosHelper } from 'Services/AxiosHelper';
import { LoginWithOpenIdBodyData } from 'Config';

const loginWithToken = async (data: any): Promise<any> =>
  (
    await axiosHelper({
      method: 'post',
      data,
    })
  ).data;

export default loginWithToken;
